import React from "react";
import {observer} from "mobx-react-lite";
import {
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    Switch
} from "@mui/material";
import './ParentSupplierToolbar.scss';
import {Clear, Refresh, Search} from "@mui/icons-material";
import {useStores} from "../../../../../stores";

type Props = {
    isParent: boolean
    children?: React.ReactNode
}
export const ParentSupplierToolbar: React.FC<Props> = observer(({isParent, children}) => {
    const {p, supplierNormalizationStore} = useStores();
    const _parent_supplier = p.p.parentSupplierAltName ?? 'Parent Supplier';
    const searchTitle = isParent ? `Enter ${_parent_supplier}` : `Enter ${p.supplierDataName} name`;

    return (
        <Grid container spacing={2} alignItems="flex-end" justifyContent="flex-start"
              className="parent-suppliers-toolbar">
            <Grid>
                <FormControl variant="standard" fullWidth={true} className="search-field">
                    <InputLabel htmlFor="parent-supplier-search-field">
                        {searchTitle}
                    </InputLabel>
                    <Input
                        id="parent-supplier-search-field"
                        type="text"
                        fullWidth={true}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="clear search"
                                    disabled={supplierNormalizationStore.searchFilter === ''}
                                    onClick={() => supplierNormalizationStore.search = ''}>
                                    <Clear/>
                                </IconButton>
                                <IconButton
                                    aria-label="search"
                                    onClick={() => supplierNormalizationStore.doSearch()}>
                                    <Search/>
                                </IconButton>
                            </InputAdornment>
                        }
                        value={supplierNormalizationStore.searchFilter}
                        onChange={e => supplierNormalizationStore.search = e.target.value}
                    />
                </FormControl>
            </Grid>
            <Grid>
                <IconButton aria-label="refresh" onClick={() => supplierNormalizationStore.refreshTableData()}>
                    <Refresh/>
                </IconButton>
            </Grid>
            {(p.getSupplierStandAloneFilter === 'TOGGLE_TO_SHOW_STANDALONE' || p.getSupplierStandAloneFilter === 'TOGGLE_TO_HIDE_STANDALONE') &&
                <Grid>
                    <FormControlLabel
                        label="Show standalone suppliers"
                        control={<Switch
                            color="primary"
                            checked={supplierNormalizationStore.showStandaloneFilter}
                            onClick={() => supplierNormalizationStore.showStandAlone = !supplierNormalizationStore.showStandaloneFilter}
                        />}/>
                </Grid>
            }
            {children}
        </Grid>
    );
})
